import { useMemo, useState } from 'react';
import { useQuery } from 'react-query';

import { Button, InfoBox, Modal } from 'src/components';
import { useUserActions, useUserState } from 'src/contexts/UserContext';
import { UsersService } from 'src/services';

const formatRetryWindowText = (retryWindowEndsInDays: number | null): string => {
  if (retryWindowEndsInDays == null || retryWindowEndsInDays === 0) {
    return 'przez najbliższe dni';
  }
  if (retryWindowEndsInDays === 1) {
    return 'przez 1 dzień';
  }
  return `przez ${retryWindowEndsInDays} dni`;
};

export const PaymentIssueInfo: React.FC = () => {
  const { hasPaymentIssue } = useUserState();
  const { openCardForm } = useUserActions();
  const [showDetails, setShowDetails] = useState(false);

  const { data } = useQuery(
    ['paymentIssueInfo'],
    UsersService.getPaymentIssueInfo,
    { enabled: hasPaymentIssue },
  );
  const retryWindowText = useMemo(
    () => formatRetryWindowText(data?.retryWindowEndsInDays ?? null),
    [data?.retryWindowEndsInDays],
  );

  if (!hasPaymentIssue) {
    return null;
  }

  return (
    <>
      <div>
        <InfoBox
          mode="warning"
          message={`Mamy problem z pobraniem płatności. System będzie próbował pobrać środki ${retryWindowText}.`}
        /><br/>
        <Button
          label="Szczegóły"
          variant="outlined"
          color="default"
          onClick={() => setShowDetails(true)}
        />
      </div>

      <Modal open={showDetails}>
        <Modal.Title>Problem z płatnością</Modal.Title>
        <Modal.Content>
          Ostatnia próba pobrania płatności nie powiodła się. System będzie
          ponawiał próbę pobrania środków {retryWindowText}.
          Do tego czasu Twoje konto pozostaje w trakcie weryfikacji płatności.
        </Modal.Content>
        <Modal.Actions>
          <Button
            label="Zamknij"
            variant="outlined"
            color="default"
            onClick={() => setShowDetails(false)}
          />
          <Button
            label="Zmień kartę"
            onClick={() => {
              setShowDetails(false);
              openCardForm();
            }}
          />
        </Modal.Actions>
      </Modal>
    </>
  );
};
